"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PageMedia = _interopRequireDefault(require("../../SIA-WEBSITE/PageMedia/PageMedia"));
var _GoBackButton = _interopRequireDefault(require("../../SIA-WEBSITE/GoBackButton/GoBackButton"));
var _SIACMSContent = _interopRequireDefault(require("../../SIA-WEBSITE/SIACMSContent/SIACMSContent"));
var _AppHeader = _interopRequireDefault(require("../../AppHeader/AppHeader"));
var _MasterarbeitTop = _interopRequireDefault(require("./ArticleTop/MasterarbeitTop"));
var _MasterarbeitList = _interopRequireDefault(require("../MasterarbeitList/MasterarbeitList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-masterarbeit {\n  display: flex;\n  flex-direction: column;\n  max-width: 66rem;\n  margin: auto;\n  align-items: center; }\n  .sia-masterarbeit .container {\n    width: 100%;\n    max-width: 698px; }\n  .sia-masterarbeit .app-header {\n    width: 100%; }\n  .sia-masterarbeit .recomended-items {\n    width: 100%; }\n\n@media (max-width: 42rem) {\n  .sia-masterarbeit .container {\n    max-width: 100%;\n    padding-inline: 16px; }\n  .sia-masterarbeit .recomended-items {\n    padding-inline: 8px; } }\n\n@media (max-width: 66rem) {\n  .sia-masterarbeit .container {\n    max-width: 508px;\n    padding-inline: 16px; }\n  .sia-masterarbeit .recomended-items {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAMasterarbeit_SIAMasterarbeit";
  const element = document.querySelector("style[data-sass-component='SIAMasterarbeit_SIAMasterarbeit']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getFiltersString = _ref => {
  let {
    year,
    type,
    school,
    pageSize
  } = _ref;
  const filters = [];
  if (type) {
    filters.push('type=' + type);
  }
  if (school) {
    filters.push('school=' + school);
  }
  if (year) {
    filters.push('year=' + year);
  }
  if (pageSize) {
    filters.push('page_size=' + pageSize);
  }
  return filters.join('&');
};
const getMasterpreisAppHeaderData = (type, lang) => {
  const appHeaders = {
    ak: {
      appName: 'Masterpreis-Masterarbeiten',
      link: `/${lang}/mp_architektur/masterarbeiten`,
      label: 'masterpreis.mp_architektur.masterarbeiten.name'
    },
    ig: {
      appName: 'Masterpreis-Masterarbeiten',
      link: `/${lang}/mp_ingenieurbau/masterarbeiten`,
      label: 'masterpreis.mp_ingenieurbau.masterarbeiten.name'
    }
  };
  return appHeaders[type] || appHeaders['ig'];
};
const SIAMasterarbeit = _ref2 => {
  let {
    item,
    history,
    lang,
    translate,
    cmsAdapter
  } = _ref2;
  const [recomendedItems, setRecomendedItems] = (0, _react.useState)([]);
  const media = item?.pictures_gallery?.map(_ref3 => {
    let [picture] = _ref3;
    if (picture.teaser_image) {
      return {
        imagePlaceholder: picture?.teaser_image[0].desktop?.url,
        imagePlaceholderTablet: picture?.teaser_image[0].tablet?.url,
        imagePlaceholderMobile: picture?.teaser_image[0].mobile?.url,
        src: picture?.url,
        type: 'VIDEO',
        copyright: {
          copyright: picture.copyright,
          title: picture.title
        }
      };
    }
    return {
      src: picture?.desktop?.url,
      srcTablet: picture?.tablet?.url,
      srcMobile: picture?.mobile?.url,
      type: 'IMAGE',
      copyright: {
        copyright: picture.copyright,
        title: picture.title
      }
    };
  });
  const appHeaderData = getMasterpreisAppHeaderData(item.masterpreis_type.masterpreis_code, lang);
  (0, _react.useEffect)(() => {
    cmsAdapter && getItemsFunc();
  }, [cmsAdapter]);
  const getItemsFunc = async () => {
    const filtersString = getFiltersString({
      type: item.masterpreis_type.masterpreis_code,
      year: item.year,
      pageSize: 5
    });
    const data = await cmsAdapter.fetchMasterarbeiten(lang, filtersString);
    setRecomendedItems(data.items.filter(el => el.id != item.id));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-masterarbeit "
  }, /*#__PURE__*/_react.default.createElement(_AppHeader.default, _extends({
    translate: translate
  }, appHeaderData)), /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), media?.length > 0 && /*#__PURE__*/_react.default.createElement(_PageMedia.default, {
    items: media,
    customConfig: {
      dots: false
    },
    showCounter: media.length > 1,
    showModal: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_MasterarbeitTop.default, {
    item: item
  }), item.page_bottom && /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: item.page_bottom,
    history: history,
    translate: translate
  })), recomendedItems.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "recomended-items"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06 sia-margin-02-bottom sia-margin-04-top"
  }, translate('cms.article-box-area.title')), /*#__PURE__*/_react.default.createElement(_MasterarbeitList.default, {
    items: recomendedItems,
    lang: lang
  })));
};
var _default = exports.default = SIAMasterarbeit;